import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class AccountService extends AbstractService {

    getAccounts(options) {
        let url = '';
        if (options) {
            const { sort, isActive, module, type, search, page } = options;
            url = Facade.getApiRoot() + `bo/accounts?pageSize=100&pageIndex=${page}${sort ? '&sortOrder=' + sort : '&sortOrder=alpha_asc'}${isActive ? '&isActive=true' : ''}${module ? '&module=' + module : ''}${type ? '&accountType=' + type : ''}${search ? '&q=' + search : ''}`;
        } else {
            url = Facade.getApiRoot() + 'bo/accounts?pageSize=1000&pageIndex=1&sortOrder=alpha_asc';
        }

        return this.request({
            method: 'GET',
            url,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    accounts: await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    getAccount(id) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/accounts/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    addAccount(options) {
        return this.request({
            method: 'POST',
            url:  Facade.getApiRoot() + 'bo/accounts',
            json: {
                name: options.name,
                type: options.type,
                email: options.email,
                logo_url: options.logoUrl,
                site_id: options.siteId ? options.siteId : null,
                currency: options.currency,
                shipping_country: options.shippingCountry,
                tax_mode: options.taxMode,
                modules: {
                    SPE: options.modules.spe,
                    ADBOX: options.modules.adbox,
                    CATALOG: options.modules.catalog,
                    PERF: options.modules.perf,
                    SLIDER: options.modules.slider,
                    MAIL: options.modules.mail,
                    PRICING_ENGINE: options.modules.pricingEngine,
                    MP: options.modules.mp,
                    TRENDS: options.modules.trends
                },
                spe_config: options.speConfig,
                pe_config: options.peConfig,
                trends_config: options.trendsConfig,
                perf_config: options.perfConfig,
                slider_config: options.sliderConfig,
                adbox_config: options.adboxConfig,
                dm_config: {
                    email_addresses: options.dmConfig.emailAddresses,
                    sending_hour: options.dmConfig.sendingHour,
                },
                is_active: true,
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    updateAccount(options, id) {
        return this.request({
            method: 'PUT',
            url:  Facade.getApiRoot() + 'bo/accounts/' + id,
            json: {
                name: options.name,
                type: options.type,
                email: options.email,
                logo_url: options.logoUrl,
                site_id: options.siteId,
                currency: options.currency,
                shipping_country: options.shippingCountry,
                tax_mode: options.taxMode,
                modules: options.mudules ? {
                    SPE: options.modules.spe,
                    ADBOX: options.modules.adbox,
                    CATALOG: options.modules.catalog,
                    PERF: options.modules.perf,
                    SLIDER: options.modules.slider,
                    MAIL: options.modules.mail,
                    PRICING_ENGINE: options.modules.pricingEngine,
                    MP: options.modules.mp,
                    TRENDS: options.modules.trends
                } : null,
                spe_config: options.speConfig,
                pe_config: options.peConfig,
                trends_config: options.trendsConfig,
                perf_config: options.perfConfig,
                slider_config: options.sliderConfig,
                adbox_config: options.adboxConfig,
                dm_config: options.dmConfig ? {
                    email_addresses: options.dmConfig.emailAddresses,
                    sending_hour: options.dmConfig.sendingHour,
                } : null,
                is_active: options.isActive,
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    deleteAccount(id) {
        return this.request({
            method: 'DELETE',
            url:  Facade.getApiRoot() + 'bo/accounts/' + id,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    getAccountUsers(id) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + `bo/accounts/${id}/users`,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    getModule(id, module) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + `bo/accounts/${id}/modules/${module}`,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    duplicateAccount(id, name) {
        return this.request({
            method: 'POST',
            url:  Facade.getApiRoot() + 'bo/accounts/' + id + '/duplicate?newName=' + name,
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    getExportData(id) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/accounts/' + id + '/export',
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    addCategories(categories, accountId) {
        return this.request({
            method: 'POST',
            url:  Facade.getApiRoot() + 'bo/accounts/' + accountId + '/categories',
            json: categories
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }

    getExportMissingAdditionalData(accountId, options) {
        return this.request({
            method: 'GET',
            url: `${Facade.getApiRoot()}bo/accounts/${accountId}/missing-additional-data?period=${options.period}`
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }
}

export default new AccountService();
